import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

export const validate: FormValidator<Pick<ChallengeFormType, 'distance'>> = ({
  distance,
}) => {
  return { isValid: true };
};
